// lodash packages must be imported this way to work with ng-packagr
import * as isPlainObjectImport from "lodash.isplainobject";
const isPlainObject = (<any>isPlainObjectImport).default || isPlainObjectImport;

export enum DiffChange {
    ADDITION,
    DELETION,
    ALTERATION,
}

export interface DiffEntry {
    type: DiffChange;
    key: PropertyKey;
    parentPath: Array<PropertyKey>;
    objects: [object, object];
}

export function diff(o1: object, o2: object, parentPath: Array<PropertyKey> = []): Array<DiffEntry> {
    let d: Array<DiffEntry> = [];
    for (const key of new Set([ ...Object.keys(o1), ...Object.keys(o2) ])) {
        const o1HasKey = o1.hasOwnProperty(key);
        const o2HasKey = o2.hasOwnProperty(key);

        if (o1HasKey && !o2HasKey) {
            d.push({ type: DiffChange.DELETION, key, parentPath, objects: [o1, o2] });
        } else if (!o1HasKey && o2HasKey) {
            d.push({ type: DiffChange.ADDITION, key, parentPath, objects: [o1, o2] });
        } else {
            if (
                (isPlainObject(o1[key]) && isPlainObject(o2[key]))
                || (Array.isArray(o1[key]) && Array.isArray(o2[key]))
            ) {
                d = d.concat(diff(o1[key], o2[key], [...parentPath, key]));
            } else if (o1[key] !== o2[key]) {
                d.push({ type: DiffChange.ALTERATION, key, parentPath, objects: [o1, o2] });
            }
        }
    }
    return d;
}
